import React, { Component } from 'react'
import { Button } from 'antd'
import './sidemenu.css'
import { ReactComponent as BRL_Transferir } from '../../images/wallet/wallet_icons-07.svg'
import { ReactComponent as  BRL_Depositar } from '../../images/wallet/wallet_icons-08.svg'
import { ReactComponent as  BTC_Transferir } from '../../images/wallet/wallet_icons-04.svg'
import { ReactComponent as  BTC_Depositar } from '../../images/wallet/wallet_icons-05.svg'
import { ReactComponent as  BRL_BTC } from '../../images/wallet/wallet_icons-09.svg'
import { ReactComponent as  BTC_BRL } from '../../images/wallet/wallet_icons-10.svg'

import { ReactComponent as  BRL } from '../../images/wallet/brl_real.svg'
import { ReactComponent as  BTC } from '../../images/wallet/btc_bitcoin.svg'
import { ReactComponent as  RIB } from '../../images/wallet/Ribus.svg'
import { ReactComponent as  Conversao } from '../../images/wallet/conversao.svg'

export default class SideMenu extends Component {

    returnIcon = (type, i) => {
        if(type === 'brl' && i === 1) {
            return <BRL_Depositar className="iconeSideMenu" />
        } else if(type === 'brl' && i === 2) {
            return <BRL_Transferir className="iconeSideMenu" />
        } else if(type === 'btc' && i === 1) {
            return <BTC_Depositar className="iconeSideMenu" />
        } else if(type === 'btc' && i === 2) {
            return <BTC_Transferir className="iconeSideMenu" />
        } else if(type === 'conversao' && i === 1) {
            return <BRL_BTC className="iconeSideMenu" />
        } else {
            return <BTC_BRL className="iconeSideMenu" />
        }
    }

    render() {
        const screen = window.innerWidth
        return (
            <>
                {screen > 1024 ? 
                <div>
                    <div id={this.props.tab1} onClick={() => this.props.onClick(this.props.tab1)} className={`tabWallet ${this.props.tabAtiva == this.props.tab1 ? 'tabWalletActive' : ''}`}>
                        <div className='divIconeTab'>{this.returnIcon(this.props.type, 1)}</div>
                        <div className='divNomeTab'><label className='nomeTab'>{this.props.tab1}</label></div>
                    </div> 

                    <div id={this.props.tab2} onClick={() => this.props.onClick(this.props.tab2)} className={`tabWallet ${this.props.tabAtiva == this.props.tab2 ? 'tabWalletActive' : ''}`}>
                        <div className='divIconeTab'>{this.returnIcon(this.props.type, 2)}</div>
                        <div className='divNomeTab'><label className='nomeTab'>{this.props.tab2}</label></div>
                    </div>  
                </div>
                : 
                <div className="d-flex sideMenuWrapper">
                    <Button id={this.props.tab1} className={this.props.tabAtiva === this.props.tab1 ? 'sideActive' : ''} id={this.props.tab1} onClick={() => this.props.onClick(this.props.tab1)}>{this.props.tab1}</Button>
                    <Button id={this.props.tab2} className={this.props.tabAtiva === this.props.tab2 ? 'sideActive' : ''} id={this.props.tab2} onClick={() => this.props.onClick(this.props.tab2)}>{this.props.tab2}</Button>
                </div>
                }
            </>
        )
    }
}